// extracted by mini-css-extract-plugin
export var item = "Subnav-module--item--28e45";
export var subnav = "Subnav-module--subnav--3fd5a";
export var text = "Subnav-module--text--a5746";
export var wrapper = "Subnav-module--wrapper--fd802";